<template>
  <th
    :class="alignCls"
    colspan="1"
    rowspan="1"
  >
    <div :class="cellClasses">
      <template v-if="column.type === 'expand'">
        <span v-if="!column.renderFilter">{{ column.title || '' }}</span>
        <table-render
          v-else
          :render="column.renderFilter"
          :column="column"
          :index="index" />
      </template>
      <template v-else-if="column.type === 'selection'"/>
      <template v-else>
        <div
          v-if="column.filterable"
          v-show="table.filtersVisible !== false">

          <SelectFilter
            v-if="column.filterable.type === 'select'"
            key="filter-component"
            v-model="filterValue"
            :options="selectOptions(column.filterable)"
            :opts="column.filterable"
            @change="onFilterChange()"
          />

          <UnitsFilter
            v-else-if="column.filterable.type === 'units'"
            key="filter-component"
            v-model="filterValue"
            :opts="column.filterable"
            @change="onFilterChange()"
          />

          <DateFilter
            v-else-if="column.filterable.type === 'date'"
            key="filter-component"
            v-model="filterValue"
            :opts="column.filterable"
            @change="onFilterChange()"
          />

          <InputFilter
            v-else
            key="filter-component"
            v-model="filterValue"
            @change="onFilterChange()"
          />

        </div>
      </template>
    </div>
  </th>
</template>
<script>
import { isFunction } from 'lodash';

import tableRender from './table-render';
import * as FilterComponents from '../filters';

import Mixin from './mixin';

export default {
  name: 'TableThFilter',
  components: {
    tableRender,
    ...FilterComponents,
  },
  mixins: [Mixin],
  inject: ['table', 'cssClasses'],
  props: {
    column: { type: Object, required: true },
    index: { type: Number, required: true },
  },
  data() {
    return {
      filterValue: null,
    };
  },
  computed: {
    alignCls() {
      return this.computeAlignCls(this);
    },
    cellClasses() {
      return [
        this.cssClasses.cell,
      ];
    },
    filter() {
      const { key } = this.column;
      const filter = this.table.filters[key];
      if (!filter) return null;
      return filter;
    },
  },
  watch: {
    filter: {
      handler() {
        this.filterValue = this.filter;
      },
      immediate: true,
    },
  },
  methods: {
    selectOptions({ options }) {
      return (isFunction(options)) ? options.call(this) : options;
    },
    onFilterChange() {
      const { column, filterValue: value } = this;
      this.table.onFilter({ column, value });
    },
  },
};
</script>

<style scoped>
.ivu-table-cell {
  width: 100%;
}
</style>
